import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const mainBody = document.getElementById('main-body');
    if (mainBody) {
      mainBody.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop; 